import { type Day } from '@choco-admin/types';

/** Week order for both the summary card and the edit modal. */
export const DAYS: Day[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const CUTOFF_TYPE_LABELS: Record<string, string> = {
  no_cutoff: 'No cutoff',
  strict: 'Strict cutoff',
  flexible: 'Flexible cutoff',
};

// Both formatters match the chat-level summary on the Chats page word for word,
// since the two screens now show the same table.

/** "23:59:59" -> "23:59" for display */
export const formatTime = (time: string): string =>
  time?.slice(0, 5) || '23:59';

/** Lead time in days -> human label, mirroring the modal's day selector */
export const formatLeadTime = (leadTime: string): string => {
  const days = parseInt(leadTime, 10);
  if (Number.isNaN(days) || days === 0) return 'Same day';
  return `${days} day${days === 1 ? '' : 's'} before`;
};
